import { z } from "zod/v4";
export const KeyValuePairSchema = z.strictObject({
    key: z.string(),
    value: z.string().optional().nullable(),
});
